import React from 'react';

const ArrowRight = ({ size = 36, color = 'currentColor', ...other }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="다음 페이지로 가기"
      {...other}
    >
      <path
        d="M13.8323 31.7875L11.7109 29.6662L23.3785 17.9995L11.7109 6.33226L13.8323 4.21094L26.5602 16.9389C27.1009 17.479 27.1425 18.3298 26.685 18.9183L26.5495 19.072L13.8323 31.7875Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowRight;
